export default __webpack_public_path__ + "static/ban1-2d0ed26e34d616d04411b43ecc4c3d30.png";